import { Col, Popover, Row } from "antd";
import { toLogout } from "../utils/APIs";

import { FormattedMessage } from "react-intl";

import { useNavigate } from "react-router-dom";
export const HeaderUser = ({ step, updateStep, display }) => {
  const navigate = useNavigate();

  const logout = async () => {
    toLogout().then((res) => {
      navigate("/login");
    });
  };

  return (
    <>
      <Row gutter={24} style={{ marginRight: "1vh" }}>
        <Col span="12" style={{ marginTop: "2vh" }}>
          <img
            className="roi--cursor"
            onClick={() => navigate("/admin")}
            src="/images/icons/monitoringText.png"
            style={{ width: "300px", marginLeft: "2vh" }}
          />
        </Col>

        <Col span="12" style={{ marginTop: "1vh", textAlign: "right" }}>
          <img
            src="/images/icons/back.svg"
            style={{ marginLeft: "20px", width: "14px" }}
            className="roi--cursor"
            onClick={() => navigate(-1)}
          />
          {/* <img
            src="/images/icons/t_plus.svg"
            style={{ marginLeft: "20px", width: "14px" }}
            className="roi--cursor"
            onClick={() => toUpdateFontSize(true, 0.1)}
          />
          <img
            src="/images/icons/t_moins.svg"
            style={{ marginLeft: "20px", width: "14px" }}
            className="roi--cursor"
            onClick={() => toUpdateFontSize(false, 0.1)}
          /> */}

          <img
            src="/images/icons/settings.png"
            style={{ marginLeft: "30px", width: "30px" }}
            className="roi--cursor"
            onClick={() => navigate("/settings")}
          />

          <Popover
            content={
              <Row>
                <Col span="2">
                  <img
                    src="/images/icons/language.svg"
                    style={{ width: "28px" }}
                  />
                </Col>
                <Col span="22">
                  <span
                    className="roi--language-popover"
                    style={{ marginLeft: "2vh" }}
                  >
                    <FormattedMessage id="usaLanguage" />
                  </span>
                </Col>
              </Row>
            }
            title=""
            trigger="click"
            //onVisibleChange={this.handleVisibleChange}
          >
            <img
              src="/images/icons/language.svg"
              style={{ marginLeft: "20px", width: "28px" }}
              className="roi--cursor"
            />
            <img
              src="/images/icons/arrow-bottom.png"
              style={{ verticalAlign: "bottom" }}
            />
          </Popover>
          <img
            src="/images/icons/logout.svg"
            style={{ marginLeft: "30px", width: "28px" }}
            className="roi--cursor"
            onClick={() => logout()}
          />
        </Col>
      </Row>
    </>
  );
};
